var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "75px",
    viewBox: "0 0 66 75",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0134e-15 1.50779e-16L5.43239 7.53895e-17L5.43239 2.71619L3.76948e-17 2.71619L5.0134e-15 1.50779e-16Z",
    transform: "matrix(0.70710677 -0.70710677 0.70710677 0.70710677 11.210747 4.01538)",
    id: "Path",
    fill: "#A4AFC1",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48032e-14 1.36455e-14L5.43239 7.53895e-17L5.43239 2.71619L0 2.71619L2.48032e-14 1.36455e-14Z",
    transform: "matrix(0.70710677 -0.70710677 0.70710677 0.70710677 0.16503382 15.05654)",
    id: "Path",
    fill: "#A4AFC1",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42369e-18 0L2.71619 1.26466e-14L2.71619 5.43239L1.98369e-14 5.43239L9.42369e-18 0Z",
    transform: "matrix(0.70710677 -0.70710677 0.70710677 0.70710677 0.64445186 2.088012)",
    id: "Path",
    fill: "#A4AFC1",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    transform: "translate(2 35)",
    id: "Oval",
    fill: "#BEEBFC",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5C6 6.68333 9.832 1.83611 15 0.441667C14.0347 0.180556 13.0427 0 12 0C5.37333 0 0 5.59722 0 12.5C0 19.4028 5.37333 25 12 25C13.0427 25 14.0347 24.8194 15 24.5583C9.832 23.1639 6 18.3167 6 12.5Z",
    transform: "translate(3 35)",
    id: "Path",
    fill: "#FFFFFD",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 28C6.28 28 0 21.72 0 14C0 6.28 6.28 0 14 0C21.72 0 28 6.28 28 14C28 21.72 21.72 28 14 28ZM14 4C8.488 4 4 8.48533 4 14C4 19.5147 8.488 24 14 24C19.512 24 24 19.5147 24 14C24 8.48533 19.512 4 14 4Z",
    transform: "translate(0 33)",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C3.81367 16 0 12.4107 0 8C0 3.58933 3.81367 0 8.5 0C13.1863 0 17 3.58933 17 8C17 12.4107 13.1863 16 8.5 16ZM8.5 4C6.15683 4 4.25 5.79467 4.25 8C4.25 10.2053 6.15683 12 8.5 12C10.8432 12 12.75 10.2053 12.75 8C12.75 5.79467 10.8432 4 8.5 4Z",
    transform: "translate(49 59)",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22C4.9335 22 0 17.0665 0 11C0 4.9335 4.9335 0 11 0C17.0665 0 22 4.9335 22 11C22 17.0665 17.0665 22 11 22ZM11 4.125C7.20775 4.125 4.125 7.2105 4.125 11C4.125 14.7895 7.20775 17.875 11 17.875C14.7922 17.875 17.875 14.7895 17.875 11C17.875 7.2105 14.7922 4.125 11 4.125Z",
    transform: "translate(44 8)",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.013579 0.0912688L27.6687 -2.34096e-16L27.6551 4.12582L4.79975e-17 4.21709L0.013579 0.0912688Z",
    transform: "matrix(0.83185726 -0.55498964 0.55498964 0.83185726 23.36607 38.38217)",
    id: "Path",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0755688 0.0108038L4.20491 0L4.12934 28.7438L0 28.7546L0.0755688 0.0108038Z",
    transform: "matrix(0.40098867 -0.91608304 0.91608304 0.40098867 24.827372 54.526665)",
    id: "Path",
    fill: "#000000",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/46.f96e877f9a0ac2ab9ff27de1404057b5.svg";
export { ForwardRef as ReactComponent };